import { render, staticRenderFns } from "./emptyView.vue?vue&type=template&id=d2b3154e&"
import script from "./emptyView.vue?vue&type=script&lang=js&"
export * from "./emptyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports